import React from "react";
import ProductLink from "components/enterprise/ProductLink";
import LicenseCheck from "license/LicenseCheck";
const EnterpriseProductLink = ({
  children = null,
  clusterId = null,
  href = "",
  licenseSubject = "/license/enterprise"
}) => /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject, displayLicenseWarning: false, hideChildren: true }, /* @__PURE__ */ React.createElement(ProductLink, { href, clusterId }, children));
export default EnterpriseProductLink;
